import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import { setModoTela, initForm } from './usuarioActions';

class UsuarioForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={this.props.alterarSenha ? 'readOnly' : readOnly} />

							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail *'
								placeholder='Informe o E-mail'
								cols='12 12 12 12'
								readOnly={this.props.alterarSenha ? 'readOnly' : readOnly} />

							{!this.props.configuracao && (
								<Field
									name='senha'
									component={LabelAndInput}
									type="password"
									label='Senha *'
									placeholder='Informe a Senha'
									cols='12 12 12 12'
									readOnly={readOnly} />
							)}

						</Row>

						{!this.props.alterarSenha &&
						<Row>

							<Grid cols='12 12 12 12'>
								<label style={{ marginBttom: 8 }}>Configuração das Permissões</label>
							</Grid>

							<Field
								name='permissao_acesso'
								component={LabelAndCheckbox}
								label='Cadastro e gestão de usuários'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='permissao_configuracao'
								component={LabelAndCheckbox}
								label='Realiza configurações (status, prioridade, categoria e tipo)'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='permissao_cadastro'
								component={LabelAndCheckbox}
								label='Realiza cadastros (cliente, fornecedor, transportadora e produto)'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='permissao_solicita_compra'
								component={LabelAndCheckbox}
								label='Realiza solicitações de compra'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='permissao_gerencia_compra'
								component={LabelAndCheckbox}
								label='Realiza a gestão das solicitações de compra'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='permissao_visualiza_compra'
								component={LabelAndCheckbox}
								label='Apenas visualiza as solicitações de compra'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='permissao_gerencia_pedido'
								component={LabelAndCheckbox}
								label='Realiza a gestão dos pedidos'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />							
							
							<Field
								name='permissao_visualiza_pedido'
								component={LabelAndCheckbox}
								label='Apenas visualiza os pedidos'
								placeholder='Informe'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
						</Row>}

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UsuarioForm = reduxForm({form: 'usuarioForm', destroyOnUnmount: false})(UsuarioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioForm')(state),
	registro: state.usuario.registro,
	listaPerfil: state.usuario.listaPerfil
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm);
